import { render, staticRenderFns } from "./KeyValueManage.vue?vue&type=template&id=7afb298a&"
import script from "./KeyValueManage.vue?vue&type=script&lang=js&"
export * from "./KeyValueManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports